import React from 'react';

const Add = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 24H42" stroke="#737A87" strokeWidth="3" strokeMiterlimit="10" />
    <path
      d="M24 42V5.90002"
      stroke="#737A87"
      strokeWidth="3"
      strokeMiterlimit="10"
    />
  </svg>
);

export default Add;
